import { List } from "immutable";
import { Abstract, AbstractEvent, AbstractListItem, AbstractType, GradingGroup } from "../models/abstract";
import { FD } from "../models/financialDisclosure";
import { ItemLoadingState } from "../models/generic";

export interface AdminAbstractState {
    abstracts: List<Abstract>;
    events: List<AbstractEvent>;
    FDs: List<FD>;
    listAbstracts: List<AbstractListItem>;
    loadingAbstract: ItemLoadingState;
    loadingEvent: ItemLoadingState;
    loadingFDs: boolean;
    loadingListAbstracts: boolean;
    loadingGroup: ItemLoadingState;
    loadingGroups: ItemLoadingState;
    loadingType: ItemLoadingState;
    loadingTypes: boolean;
    groups: List<GradingGroup>;
    types: List<AbstractType>;
}

export const initialState: AdminAbstractState = {
    abstracts: List(),
    events: List(),
    FDs: List(),
    listAbstracts: List(),
    loadingAbstract: {},
    loadingEvent: {},
    loadingFDs: true,
    loadingListAbstracts: true,
    loadingGroup: {},
    loadingGroups: {},
    loadingType: {},
    loadingTypes: false,
    groups: List(),
    types: List(),
};



// WEBPACK FOOTER //
// ./src/store/AdminAbstractState.ts